import {
  Component,
  OnInit,
  TemplateRef,
  Input,
  ViewChild,
  ElementRef,
  OnDestroy
} from '@angular/core'
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { DomSanitizer } from '@angular/platform-browser'
import { PdfService } from '../../service/pdf.service'
import { environment } from '../../../environments/environment'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { RevenueTableComponent } from 'app/securities-level/revenue-table/revenue-table.component'
import { debug, isNullOrUndefined } from 'util'
import { AuthorizeService } from '../../service/authorize.service'
import { MatMenuTrigger } from '@angular/material'

@Component({
  selector: 'app-revenue-executive-summary',
  templateUrl: './revenue-executive-summary.component.html',
  styleUrls: ['./revenue-executive-summary.component.scss'],
  providers: [PdfService]
})
export class RevenueExecutiveSummaryComponent implements OnInit, OnDestroy {
  @ViewChild(RevenueTableComponent) revenueTableComponent: RevenueTableComponent
  @Input() isFullFactSheet
  page = 1
  pdfSrc = ''
  totalPages: number
  isLoaded = false
  testLink
  revenueFilename
  isRevenueStructure = true
  @Input() printPage
  subscription: Subscription
  @ViewChild('template') template: TemplateRef<any>
  modalRef: BsModalRef
  dataType = 'Revenue'
  companyIdPsims
  checkSumbit = false
  securitySymbol
  oldSecuritySymbol
  yearF56
  hiddenFile = false
  hiddenTable = false
  hiddenPicture = false
  isAE
  previewElement


  constructor(
    private cpmService: CpmService,
    private modalService: BsModalService,
    private pdfService: PdfService,
    private sanitizer: DomSanitizer,
    private store: StoreService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService
  ) { }

  ngOnDestroy() {
    this.previewElement = null
  }

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        if (!this.oldSecuritySymbol || this.oldSecuritySymbol !== response['securitySymbol']) {
          this.previewElement = null
        }
        this.companyIdPsims = response['companyIdPsims']
        this.securitySymbol = response['securitySymbol']
        this.oldSecuritySymbol = this.securitySymbol
        this.yearF56 = response['yearF56']
        this.revenueFilename = response['revenueFilename']
        this.isAE = response['ae']
        this.getFactsheetFlagBySecuritySymbol(this.securitySymbol)
        if (!isNullOrUndefined(this.companyIdPsims)) {
          this.testLink = this.sanitizer.bypassSecurityTrustResourceUrl(
            `${environment.cpmBaseUrl}/download?type=${this.dataType}&id=${
            response['companyIdPsims']
            }`
          )
        }
      })

    this.pdfSrc = this.pdfService.getPDF()
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('COMPINFO_EDIT')
    )
  }

  emptyRevenueFilename() {
    return (this.revenueFilename === null)
  }

  onFileSelected() {
    const img: any = document.querySelector('#file')

    if (typeof FileReader !== 'undefined') {
      const reader = new FileReader()

      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result
      }

      reader.readAsArrayBuffer(img.files[0])
    }
  }

  checkFileType() {
    const fileType: String = String(this.revenueFilename)
    const pdfType: Boolean = fileType.endsWith('.pdf')

    if (pdfType === true) {
      return true
    } else {
      return false
    }
  }

  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages
    this.isLoaded = true
  }

  nextPage() {
    this.page++
  }

  prevPage() {
    this.page--
  }

  uploadFile() {
    const width = 600
    const height = 600
    const left = screen.width / 2 - width / 2
    const top = screen.height / 2 - height / 2
    this.openModal(this.template)
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg' })
    )
  }

  closeModal() {
    this.modalRef.hide()
  }

  flagRevenueChange(event) {
    this.getFactsheetFlagBySecuritySymbol(this.securitySymbol)
  }

  getResponeUpload($event) {
    this.getFactsheetFlagBySecuritySymbol(this.securitySymbol)
  }


  pdfRevenueStructure(companyIdPsims) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.cpmBaseUrl}/download?type=${
      this.dataType
      }&id=${companyIdPsims}`
    )
  }

  getYearF56() {
    if (this.yearF56 === null) {
      return null
    } else if (this.yearF56 !== null) {
      return '(56-1 ปี ' + this.yearF56 + ')'
    }
  }

  getLink(companyIdPsims) {
    if (!this.previewElement) {
      this.previewElement = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.cpmBaseUrl}/download?type=revenue&id=${companyIdPsims}`
      )
      return this.previewElement;
    } else {
       return this.previewElement;
    }
  }

  testClick(symbol) {
    this.revenueFilename = symbol
    this.checkSumbit = true
    this.previewElement = null
  }

  editRevenueTable() {
    this.hiddenFile = true
    this.hiddenTable = false
    this.revenueTableComponent.setEditFlag()
  }

  getFactsheetFlagBySecuritySymbol(symbol) {
    this.hiddenFile = false
    this.hiddenTable = true
    this.hiddenPicture = true

    this.cpmService.getFactsheetFlagBySymbol(symbol).subscribe(factsheet => {
      switch (factsheet.revenueFlag) {
        case 'Table':
          this.hiddenFile = true
          this.hiddenTable = false // --> true
          this.hiddenPicture = true // --> false
          break
        case 'File':
          this.hiddenFile = false
          this.hiddenTable = true // --> false
          this.hiddenPicture = false // --> true
          break
        default:
          this.hiddenFile = false
          this.hiddenTable = true // --> false
          this.hiddenPicture = false // -> false
      }
    })
  }

  clickEditDropdown(event: Event) {
    $(event.target)
      .closest('div')
      .next()
      .toggleClass('show')
  }

  mourseLeaveMenu() {
    $(event.target)
      .find('#editItemListRevenueExesum')
      .removeClass('show')
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/revenue-executive-summary/revenue-executive-summary.component.ts